import { ALERT_FRAGMENT } from 'features/alerts/api/fragments/alert'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { WorkspaceSliceDTO } from './types'

export const WORKSPACE_FORM_FRAGMENT: TypedDocumentNode<WorkspaceSliceDTO> = gql`
  ${ALERT_FRAGMENT}

  fragment WorkspaceFormFragment on Workspace {
    id
    alerts {
      ...AlertFragment
    }
    crmId
    csManager {
      id
      firstName
      lastName
    }
    name
    networkCode
    pipedriveLink
  }
`
